import styled from 'styled-components'
import { Link } from 'react-router-dom'

export const FooterContainer = styled.div`
    width: 100%;
    padding: 40px 24px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    /* background: #F2F2F2; */
    background: linear-gradient(180deg, #FFFFFF 0%, #FFECEE 30%, #FCD5D5 100%);
`

export const FooterLinksContainer = styled.div`
    width: 70%;
    display: flex;
    justify-content: flex-end;
    
    @media screen and (max-width: 768px) {
        width: 100%;
        justify-content: flex-start;
    }

    @media screen and (max-width: 480px) {
        flex-direction: column;
    }
`

export const FooterLinksWrapper = styled.div`
    display: flex;
`

export const FooterLinkItems = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    margin: 16px;
    text-align: left;
    width: 100%;
    box-sizing: border-box;
    color: #202020;

    @media screen and (max-width: 480px) {
        align-items: center;
    }
`

export const FooterLinkTitle = styled.h1`
    font-size: 14px;
    margin-bottom: 16px;
`

export const FooterLink = styled(Link)`
    display: flex;
    align-items: center;
    color: #202020;
    text-decoration: none;
    font-size: 14px;
    line-height: 48px;
    margin: -4px 0;

    &:hover {
        color: #ff91a2;
        transition: 0.3s ease-out
    }
`

export const SocialIcons = styled.div`
    display: flex;
    justify-content: space-between;
    align-items:center;
    width: 150px;
`

export const SocialIconLink = styled.a`
    display: flex;
    justify-content: center;
    align-items: center;
    color: #202020;
    font-size: 24px;
    width: 48px;
    height: 48px;
`

export const WhatsappIconLink = styled.a`
    display: flex;
    justify-content: center;
    align-items: center;
    color: #202020;
    font-size: 24px;
    pointer-events: none;
    width: 48px;
    height: 48px;

    @media screen and (max-width: 400px) {
        pointer-events: auto;
    }
`

export const NavLink = styled.a`
    color: #202020;
    text-decoration: none;
    margin-bottom: 0.5rem;
    font-size: 14px;
    line-height: 48px;
    margin: -4px 0;

    &:hover {
        color: #ff91a2;
        transition: 0.3s ease-out
    }

    @media screen and (max-width: 400px) {
        &:hover {
            color: #202020;
        }
    }

`

export const WhatsappNavLink = styled.a`
    color: #202020;
    text-decoration: none;
    margin-bottom: 0.5rem;
    font-size: 14px;
    pointer-events: none;
    line-height: 48px;
    margin: -4px 0;

    @media screen and (max-width: 400px) {
        pointer-events: auto;
    }
`

export const FooterCopyWrapper = styled.div`
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 40px auto 0 auto;

    @media screen and (max-width: 600px) {
        flex-direction: column;
    }
`

export const FooterLogo = styled(Link)`
    color: #202020;
    justify-self: start;
    cursor: pointer;
    text-decoration: none;
    font-size: 1.5rem;
    display: flex;
    align-items: center;
    margin-bottom: 16px;
    font-weight: bold;
`

export const WebsiteRights = styled.small`
    color: #0D0D0D;
    margin-bottom: 16px;

    @media screen and (max-width: 768px) {
        text-align: center;
    }
`